import { InjectionToken } from '@angular/core';
import { fromEvent, merge, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export const defaultOnlineDetector: Observable<boolean> = merge(
    fromEvent(window, 'online').pipe(map(() => true)),
    fromEvent(window, 'offline').pipe(map(() => false)),
).pipe(startWith(navigator.onLine));
export const OnlineDetectorInjectionToken = new InjectionToken<Observable<boolean>>('OnlineObservableInjectionToken');
